<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">完善个人信息</span>
    </navbar>
    <div class="page-content">
      <form @submit.prevent="submitHandler" novalidate="novalidate">
        <div class="group-title">实名信息</div>
        <div class="cell-group">
          <div class="input-cells">
            <div class="label-cell">
              <label>真实姓名</label>
            </div>
            <div class="input-cell">
              <input type="text" v-model="name" class="form-control">
            </div>
          </div>
          <div class="input-cells">
            <div class="label-cell">
              <label>身份证号</label>
            </div>
            <div class="input-cell">
              <input type="text" v-model="idcard" class="form-control">
            </div>
          </div>
        </div>
        <div class="group-title">收款信息</div>
        <div class="cell-group">
          <div class="input-cells">
            <div class="label-cell">
              <label>银行卡号</label>
            </div>
            <div class="input-cell">
              <input type="text" v-model="bankNo" class="form-control">
            </div>
          </div>
          <div class="input-cells">
            <div class="label-cell">
              <label>开户银行</label>
            </div>
            <div class="input-cell">
              <div class="form-control" @click="bankPicker = true">{{bankName}}</div>
              <input type="hidden" v-model="bankCode">
            </div>
          </div>
          <div class="input-cells">
            <div class="label-cell">
              <label>开户行所在地</label>
            </div>
            <div class="input-cell">
              <div class="form-control" @click="cityPicker = true">
                {{areaName}}
              </div>
              <input type="hidden" v-model="province">
              <input type="hidden" v-model="city">
            </div>
          </div>
          <div class="input-cells" v-show="subBankVisible">
            <div class="label-cell">
              <label>开户行支行名称</label>
            </div>
            <div class="input-cell">
              <input type="text" class="form-control" @click="autoPopup=true" v-model="pbcBankName" readonly>
            </div>
          </div>
        </div>
        <div class="btn-group">
          <button type="submit" class="btn-submit">保存</button>
        </div>
      </form>
    </div>
    <autocomplete
      placeholder="输入关键字过滤"
      field="branchBankName"
      :show="autoPopup"
      :source="subBankList"
      :on-select="onSubBankSelect"
      @onCancel="autoPopup=false"></autocomplete>
    <picker v-model="bankPicker" :data-items="bankList" @change="onBankChange">
      <div slot="header">请选择开户行</div>
      <button class="btn-submit" @click="onBankSelect"  slot="footer">确定</button>
    </picker>
    <picker v-model="cityPicker" :data-items="cityList" @change="onCityChange">
      <div slot="header">请选择开户行所在地</div>
      <button class="btn-submit" @click="onCitySelect"  slot="footer">确定</button>
    </picker>
    <spinner :show="loading"></spinner>
    <toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Autocomplete from 'components/autocomplete/autocomplete'
  import Picker from 'components/picker/picker'
  import Spinner from 'components/spinner/spinner'
  import Toast from 'components/toast/toast'

  export default {
    data () {
      return {
        loading: false,
        toastShow: false,
        toastText: '',
        bankList: [{
          name: 'cdeName',
          index: 0,
          values: []
        }],
        cityList: [{
          name: 'name',
          index: 0,
          values: []
        }, {
          name: 'name',
          index: 0,
          values: []
        }],
        subBankList: [],
        bankPicker: false,
        cityPicker: false,
        autoPopup: false,
        name: '',
        idcard: '',
        bankNo: '',
        bankName: '',
        bankCode: '',
        province: '',
        provinceName: '',
        cityName: '',
        city: '',
        pbcBankName: '',
        pbcBankNo: ''
      }
    },
    computed: {
      areaName () {
        let result = []
        this.provinceName && result.push(this.provinceName)
        this.cityName && result.push(this.cityName)
        return result.join(' - ')
      },
      subBankVisible () {
        return this.bankCode && this.province && this.city
      }
    },
    components: {
      Navbar,
      Autocomplete,
      Picker,
      Spinner,
      Toast
    },
    created () {
      this.token = this.$cache.getUserToken()
      this._fetchData(() => {
        if (this.bankCode && this.province && this.city) {
          this._fetchSubBank((list) => {
            this._setDefaultSubBank(list)
            this.__subBankInit = true
          })
        } else {
          this.__subBankInit = true
        }
      })
      this._fetchBankList((list) => {
        this._setDefaultBank(list)
      })
      this._fetchCity(null, (list) => {
        this._setDefaultProvince(list)
        if (!this.province) {
          this.province = list[0].id
        }
        this._fetchCity(this.province, (list) => {
          this._setDefaultCity(list)
          this.__cityInit = true
        })
      })
    },
    watch: {
      bankCode (val) {
        this.subBankList = []
        if (val && this.__subBankInit) {
          this._reloadSuBank()
        }
      },
      province (val) {
        if (val && this.__cityInit) {
          clearTimeout(this._cityTimer)
          this._cityTimer = setTimeout(() => {
            this._fetchCity(val)
          }, 500)
        }
      },
      city (val) {
        this.subBankList = []
        if (val && this.__subBankInit) {
          this._reloadSuBank()
        }
      }
    },
    methods: {
      _fetchData (cb) {
        let vm = this
        let time = Date.now()
        this.loading = true
        this.$ajax({
          url: '/czBank/getUserInfoByCz.jhtml',
          params: {
            uid: vm.token.uid,
            mac: vm.token.mac,
            time,
            sign: vm.$md5(vm.token.uid + time + '1' + vm.token.mac)
          },
          done (info) {
            vm.name = info.name
            vm.idcard = info.idcard
            vm.bankNo = info.bankNo
            vm.bankName = info.bankName
            vm.bankCode = info.bankCode
            vm.province = info.province
            vm.city = info.city
            vm.pbcBankNo = info.pbcBankNo
            cb && cb()
          },
          always () {
            vm.loading = false
          }
        })
      },
      _fetchBankList (cb) {
        let vm = this
        this.$ajax({
          url: '/getLookupCdeList.jhtml',
          params: {
            typeCode: '20008003'
          },
          done (list) {
            list = [].concat(list)
            list.splice(0, 0, {
              cdeName: '请选择',
              cdeCode: ''
            })
            vm.$set(vm.bankList[0], 'values', list)
            cb && cb(list)
          },
          fail (m) {
            vm.toastText = m
            vm.toastShow = true
          }
        })
      },
      _fetchCity (pid, cb) {
        let vm = this
        let time = Date.now()
        this.$ajax({
          url: '/czBank/getCzAreaByPid.jhtml',
          params: {
            uid: vm.token.uid,
            mac: vm.token.mac,
            time,
            sign: vm.$md5(vm.token.uid + time + '1' + vm.token.mac),
            pid: pid
          },
          done (list) {
            list = [].concat(list)
            if (pid) {
              vm.$set(vm.cityList[1], 'values', list)
            } else {
              vm.$set(vm.cityList[0], 'values', list)
            }
            cb && cb(list)
          },
          fail (m) {
            vm.toastText = m
            vm.toastShow = true
          }
        })
      },
      _fetchSubBank (cb) {
        let vm = this
        let time = Date.now()
        this.$ajax({
          url: '/czBank/getBranchBankByBankCode.jhtml',
          params: {
            uid: vm.token.uid,
            mac: vm.token.mac,
            time,
            sign: vm.$md5(vm.token.uid + time + '1' + vm.token.mac),
            bankCode: vm.bankCode,
            province: vm.province,
            city: vm.city
          },
          done (list) {
            list = [].concat(list)
            vm.subBankList = list
            cb && cb(list)
          },
          fail (m) {
            vm.toastText = m
            vm.toastShow = true
          }
        })
      },
      _reloadSuBank () {
        if (this.__subBankInit) {
          this.pbcBankName = ''
          this.pbcBankNo = ''
        }
        if (this.bankCode && this.province && this.city) {
          this._fetchSubBank()
        }
      },
      _setDefaultBank (list) {
        for (let i = 0, len = list.length; i < len; i++) {
          let item = list[i]
          if (item && item.cdeCode === this.bankCode) {
            this.bankName = item.cdeName
            this.$set(this.bankList[0], 'index', i)
            break
          }
        }
      },
      _setDefaultProvince (list) {
        for (let i = 0, len = list.length; i < len; i++) {
          let item = list[i]
          if (item && (item.id + '') === this.province) {
            this.provinceName = item.name
            this.$set(this.cityList[0], 'index', i)
            break
          }
        }
      },
      _setDefaultCity (list) {
        for (let i = 0, len = list.length; i < len; i++) {
          let item = list[i]
          if (item && (item.id + '') === this.city) {
            this.cityName = item.name
            this.$set(this.cityList[1], 'index', i)
            break
          }
        }
      },
      _setDefaultSubBank (list) {
        for (let i = 0, len = list.length; i < len; i++) {
          let item = list[i]
          if (item && item.branchBankNo === this.pbcBankNo) {
            this.pbcBankName = item.branchBankName
            break
          }
        }
      },
      _validate () {
        if (!this.name) {
          this.toastText = '请输入真实姓名'
          return !(this.toastShow = true)
        }
        if (!this.idcard) {
          this.toastText = '请输入身份证号'
          return !(this.toastShow = true)
        }
        if (!/^\d{17}[0-9xX]$/.test(this.idcard)) {
          this.toastText = '请输入正确的身份证号'
          return !(this.toastShow = true)
        }
        if (!this.bankNo) {
          this.toastText = '请输入银行卡号'
          return !(this.toastShow = true)
        }
        if (!(this.bankCode && this.bankName)) {
          this.toastText = '请选择开户行'
          return !(this.toastShow = true)
        }
        if (!(this.province && this.city)) {
          this.toastText = '请选择开户行所在地'
          return !(this.toastShow = true)
        }
        if (!(this.pbcBankNo && this.pbcBankName)) {
          this.toastText = '请输入开户行支行名称'
          return !(this.toastShow = true)
        }
        return true
      },
      submitHandler () {
        if (this._validate()) {
          let vm = this
          let time = Date.now()
          this.loading = true
          this.$ajax({
            url: '/czBank/selfImprovement.jhtml',
            params: {
              name: vm.name,
              idcard: vm.idcard,
              bankNo: vm.bankNo,
              bankName: vm.bankName,
              bankCode: vm.bankCode,
              province: vm.province,
              city: vm.city,
              pbcBankNo: vm.pbcBankNo,
              uid: vm.token.uid,
              mac: vm.token.mac,
              time,
              sign: vm.$md5(vm.token.uid + time + '1' + vm.token.mac)
            },
            done (o, p, r) {
              vm.$dialog({
                content: r.msg,
                onHide () {
                  vm.$router.replace('/user')
                }
              })
            },
            always () {
              vm.loading = false
            }
          })
        }
      },
      onBankChange (item) {
        this.bankItem = item
      },
      onCityChange (province, city) {
        this.provinceItem = province
        this.cityItem = city
        province && (this.province = province.id)
      },
      onBankSelect () {
        this.bankPicker = false
        this.bankName = this.bankItem.cdeName
        this.bankCode = this.bankItem.cdeCode
      },
      onCitySelect () {
        this.cityPicker = false
        this.provinceName = this.provinceItem.name
        this.province = this.provinceItem.id
        this.cityName = this.cityItem.name
        this.city = this.cityItem.id
      },
      onSubBankSelect (item) {
        this.pbcBankName = item.branchBankName
        this.pbcBankNo = item.branchBankNo
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .cell-group
    box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)

  .group-title
    margin px2rem(18) 0 px2rem(15) 1em
    font-size px2rem(24)
    color #275482
  .btn-submit
    width 100%
    height px2rem(100px)
    font-size px2rem(36px)
    color #fff
    border none
    background-color #60c9c8
    box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)

  .btn-group
    margin-top px2rem(60)
    width 80%
    margin-left 10%
    .btn-submit
      height px2rem(100px)
      font-size px2rem(32px)
      border-radius px2rem(8)
</style>



// WEBPACK FOOTER //
// profile-zs.vue?480f3976